// extracted by mini-css-extract-plugin
export default {"placeholder":"styles-module__placeholder__src-labstep-web-prosemirror-extensions-placeholder-plugin-_n7lx2"};